// extracted by mini-css-extract-plugin
export default {"navbarColor":"NavbarComp_navbarColor__8KhKI"};